const ActionTypes = {update_step5:'update_step5'};

var callables = {

	/**	
	 * Add user to store
	 * @param  object files
	 * @return object
	 */
	update_step5: function(step5) {
		return { type: ActionTypes.update_step5, step5 };
	}

};

export default callables;
export { ActionTypes };